import React from "react";
import { GraduationCap, Award, Calendar, MapPin, CheckCircle } from "lucide-react";
import "./Education.css";

const educationList = [
  {
    degree: "Bachelor of Engineering — Electronics & Computer Engineering",
    institution: "Amrutvahini College of Engineering, Sangamner",
    period: "Dec 2021 – May 2025",
    badge: "Undergraduate Degree",
    highlights: "Comprehensive engineering curriculum covering object-oriented architecture, computer networks, database systems, and hardware-software integration.",
  },
  {
    degree: "BE Honors — Data Science & Machine Learning",
    institution: "Pune, Maharashtra",
    period: "Jan 2024 – May 2025",
    badge: "Honors Specialization",
    highlights: "Advanced specialization focusing on applied machine learning pipelines, predictive modeling, data analysis, and mathematical foundations of AI algorithms.",
  },
];

const certificationsList = [
  {
    title: "Java Full Stack Development",
    issuer: "Cipheren Technology",
    icon: Award,
    type: "Industry Certification",
  },
  {
    title: "AIML Virtual Internship",
    issuer: "EduSkill",
    icon: Award,
    type: "Practical Specialization",
  },
  {
    title: "JavaScript (Intermediate)",
    issuer: "HackerRank",
    icon: Award,
    type: "Skills Assessment",
  },
  {
    title: "Problem Solving (Intermediate)",
    issuer: "HackerRank",
    icon: Award,
    type: "Algorithmic Assessment",
  },
];

const Education = () => {
  return (
    <section id="education" className="section section-secondary education-section">
      <div className="container">
        
        {/* SECTION HEADER */}
        <div className="section-header">
          <div className="eyebrow">07 / Academic &amp; Credentials</div>
          <h2 className="section-title">
            Education &amp; <em>Certifications</em>
          </h2>
          <p className="section-subtitle">
            Formal engineering foundations and verified industry skill credentials.
          </p>
        </div>

        {/* 2-COLUMN GRID: EDUCATION & CERTIFICATIONS */}
        <div className="edu-cert-grid">
          
          {/* COLUMN 1: EDUCATION */}
          <div className="edu-column">
            <div className="sub-column-header">
              <GraduationCap size={20} className="sub-header-icon" />
              <h3>Academic Background</h3>
            </div>

            <div className="edu-cards-list">
              {educationList.map((item, index) => (
                <div key={index} className="edu-card">
                  <div className="edu-top-row">
                    <span className="badge badge-terracotta">{item.period}</span>
                    <span className="badge badge-neutral">{item.badge}</span>
                  </div>
                  <h4 className="edu-degree">{item.degree}</h4>
                  <div className="edu-institution">
                    <MapPin size={14} className="inst-pin" />
                    <span>{item.institution}</span>
                  </div>
                  <p className="edu-highlights">{item.highlights}</p>
                </div>
              ))}
            </div>
          </div>

          {/* COLUMN 2: CERTIFICATIONS */}
          <div className="cert-column">
            <div className="sub-column-header">
              <Award size={20} className="sub-header-icon" />
              <h3>Industry Certifications</h3>
            </div>

            <div className="cert-cards-list">
              {certificationsList.map((cert, index) => (
                <div key={index} className="cert-card">
                  <div className="cert-icon-badge">
                    <Award size={18} className="cert-award-icon" />
                  </div>
                  <div className="cert-info">
                    <h4 className="cert-title">{cert.title}</h4>
                    <div className="cert-issuer">Issued by <strong>{cert.issuer}</strong></div>
                    <span className="cert-type-pill">{cert.type}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default Education;
